module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('vue-headful', {
    attrs: {
      "title": 'SGP'
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [(_vm.usuarioLogado.ds_tipo_usuario === 'ENTIDADE' && _vm.usuarioLogado.ds_cpf === null) ? _c('div', {
    staticClass: "column all-centered aviso-edital"
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.ds_tipo_usuario === 'ENTIDADE') ? _c('div', [_c('avisosLicencas')], 1) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'ENTIDADE' && _vm._.get(_vm.usuarioLogado, 'entidade.id', 0) !== 1439) ? _c('span', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('visualiza-pendencias-projeto')], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.usuarioLogado.userType === 'ENTIDADE') ? _c('visualiza-roteiro') : _vm._e()], 1)]), _vm._v(" "), (_vm.usuarioLogado.userType === 'ENTIDADE' && _vm.chamados && _vm.chamados.length > 0) ? _c('div', {
    staticClass: "alert alert-dismissible alert-warning"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.show.info = false
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._l((_vm.chamados), function(chamado) {
    return _c('span', [_vm._v("\n        Chamado número:\n        "), _c('router-link', {
      attrs: {
        "target": "_blank",
        "to": {
          name: 'cadastro-chamado-edita',
          params: {
            id: chamado.id
          }
        }
      }
    }, [_c('b', [_vm._v(_vm._s(chamado.id))])]), _vm._v("\n        - " + _vm._s(chamado.status.status)), _c('br')], 1)
  })], 2) : _vm._e(), _vm._v(" "), _vm._l((_vm.mensagens), function(msg) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.mensagens.length > 0),
        expression: "mensagens.length > 0"
      }],
      staticClass: "alert alert-link alert-dismissible alert-warning"
    }, [_c('button', {
      staticClass: "close",
      attrs: {
        "type": "button",
        "data-dismiss": "alert",
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          _vm.show.info = false
        }
      }
    }, [_vm._v("×")]), _vm._v(" "), _vm._m(3, true), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(msg)
      }
    })])
  }), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO' || !_vm._.isEmpty(_vm.projetos)) ? _c('div', [_c('AvisoMudancas')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.usuarioLogado.userType === 'ENTIDADE' && !_vm._.isEmpty(_vm.projetos)),
      expression: "usuarioLogado.userType === 'ENTIDADE' && !_.isEmpty(projetos)"
    }],
    staticClass: "alert alert-link alert-dismissible",
    staticStyle: {
      "border": "1px solid #000000 !important",
      "text-align": "justify",
      "text-justify": "inter-word"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.show.info = false
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.show),
      expression: "loading.show"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('div', [_c('Integridade')], 1)], 2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n      Inicial\n    ")]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Inicial")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('i', {
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('b', [_vm._v("Atenção")]), _vm._v(": Esta conta permite apenas ver os projetos que já foram aprovados. Se você precisar fazer alterações ou enviar novas propostas, por favor, saia desta conta e entre novamente usando a conta do "), _c('b', [_vm._v("Representante Legal")]), _vm._v(" da sua organização.\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('i', {
    staticClass: "fa fa-warning"
  }), _vm._v("   Atenção: existe(m) chamado(s) que dependem de providências da sua instituição:")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('i', {
    staticClass: "fa fa fa-info"
  }), _vm._v("   Atenção!")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('i', {
    staticClass: "fa fa-warning"
  }), _vm._v(" Atenção! Mudança de e-mail.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('p', [_vm._v("Prezados parceiros,")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Informamos que o e-mail para tratar de assuntos relacionados ao andamento do projeto mudou de\n          implementação@fbb.org.br para: "), _c('strong', [_vm._v("assessoramento@fbb.org.br")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Respeitosamente e sempre à sua disposição,")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n          Fundação Banco do Brasil"), _c('br')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b0768936!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/dashboard/Index.vue
// module id = 2055
// module chunks = 1